import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Phone, Mail, Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="py-12 border-t border-purple-200/50 mt-12 bg-gradient-to-b from-transparent to-purple-50/50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand Section */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 via-amber-400 to-pink-500 flex items-center justify-center glow-purple">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <span className="font-mystical text-2xl font-bold text-[#5B21B6]">Intuitive Matchmaker</span>
            </div>
            <p className="text-[#6D5A7D] font-whimsy">
              Discover your destined love connection through numerology
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="font-mystical text-lg font-bold text-[#2D1B3D] mb-4">Quick Links</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/services" className="text-[#6D5A7D] hover:text-[#8B5CF6] transition-colors">Services</Link>
              <Link to="/calculator" className="text-[#6D5A7D] hover:text-[#8B5CF6] transition-colors">Soulmate Calculator</Link>
              <Link to="/testimonials" className="text-[#6D5A7D] hover:text-[#8B5CF6] transition-colors">Testimonials</Link>
              <Link to="/blog" className="text-[#6D5A7D] hover:text-[#8B5CF6] transition-colors">Blog</Link>
              <Link to="/register" className="text-[#6D5A7D] hover:text-[#8B5CF6] transition-colors">Join Free Database</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-right">
            <h4 className="font-mystical text-lg font-bold text-[#2D1B3D] mb-4">Contact Karine</h4>
            <div className="flex flex-col gap-3 items-center md:items-end">
              <a 
                href="tel:678-665-4712" 
                className="inline-flex items-center gap-2 text-[#5B21B6] hover:text-[#D4AF37] font-bold text-lg transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5" />
                678-665-4712
              </a>
              <a 
                href="mailto:karine@intuitivematchmaker.com" 
                className="inline-flex items-center gap-2 text-[#6D5A7D] hover:text-[#8B5CF6] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5" />
                karine@intuitivematchmaker.com
              </a>
              {/* Social Links */}
              <div className="flex items-center gap-3 mt-2">
                <a 
                  href="https://www.facebook.com/themystictellers" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#1877F2] flex items-center justify-center text-white hover:scale-110 transition-transform"
                  data-testid="footer-facebook"
                  aria-label="Facebook"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.instagram.com/themystictellers" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] flex items-center justify-center text-white hover:scale-110 transition-transform"
                  data-testid="footer-instagram"
                  aria-label="Instagram"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-purple-200/30 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[#8C7A9C]">
          <p className="flex items-center gap-1">
            Made with <Heart className="w-4 h-4 text-pink-500 fill-pink-500" /> by Karine Burt
          </p>
          <p>© {new Date().getFullYear()} Intuitive Matchmaker. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
